import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Divider from "@mui/material/Divider";
import {
  Box,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import IconExpandLess from "@mui/icons-material/ExpandLess";
import IconExpandMore from "@mui/icons-material/ExpandMore";
import { sidebardata } from "./sidebarData";
import ArrowCircleRightRoundedIcon from "@mui/icons-material/ArrowCircleRightRounded";

import CloseIcon from "@mui/icons-material/Close";
import useAuth from "../../hooks/useAuth";
import { isFeatureAllowed } from "../../constants/Constants";

const AppMenuItem = (props) => {
  const { title, icon, items = [], path } = props;
  const isExpandable = items && items.length > 0;
  const [open, setOpen] = useState(false);

  function handleClick(arg) {
    setOpen(!open);
    if (arg !== "main" && (props.isOpen ?? false)) {
      props.setIsOpen && props.setIsOpen((oldState) => !oldState);
    }
    //Removed as setOpen is disturbing onevery click
    // if (arg !== "main") {
    //   props.setIsOpen && props.setIsOpen((oldState) => !oldState);
    // }
  }
  // const { authUser } = useAuth();
  // const isRouteAllowed = (allowedRoles = []) => {
  //   return authUser?.roles.find((role) => allowedRoles.includes(role));
  // };

  const isRouteAllowed = (allowedRoles = []) => { return true };
  const MenuItemRoot = isExpandable ? (
    <ListItemButton onClick={() => handleClick("main")} className="icon">
      {!!icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText primary={title} inset={!icon} />
      {open ? <IconExpandLess /> : <IconExpandMore />}
    </ListItemButton>
  ) : (
    <NavLink
      to={path}
      className="link"
      style={({ isActive }) => (isActive ? { color: "#007676" } : {})}
    >
      <ListItemButton className="link" onClick={() => handleClick("icon")}>
        {!!icon && <ListItemIcon>{icon}</ListItemIcon>}
        <ListItemText
          primary={title}
        // inset={!icon}
        />
      </ListItemButton>
    </NavLink>
  );

  //This is for tender submenu
  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      {/* <Divider /> */}
      <List component="div" disablePadding onClick={() => handleClick("sub")}>
        {items
          .filter((item) => isRouteAllowed(item.allowedRoles))
          .map((item, index) => (
            <AppMenuItem {...item} key={index} />
          ))}
        <Divider />
      </List>
    </Collapse>
  ) : null;

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
};

const Sidebar = ({ isOpen, setIsOpen }) => {
  const { authUser } = useAuth();
  const isRouteAllowed = (checkAdminRules) => {
    if (!authUser) {
      return false;
    }
    let allow = true;
    if (checkAdminRules === "allow") {
      return allow;
    }
    if (!isFeatureAllowed(authUser.packages, checkAdminRules)) {
      allow = false;
    }
    return allow
  };
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box>
      <Box className={isOpen ? "drawer open" : "drawer"}>
        <List //for submenu
          component="nav"
          disablePadding
          style={{
            width: "100%",
            fontSize: "34px",
          }}
          // style={{ width: isOpen ? "330px" : "70px" }}
          className="sidebar"
        >
          <Box
            className="topSection"
            sx={{
              mx: {
                xs: "auto",
                md: 0,
                // backgroundColor: "rgb(245, 242, 242)"
              },
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "1%",
              }}
            >
              <Typography
                variant="span"
                sx={{
                  display: {
                    md: isOpen ? "block" : "none",
                    xs: "block",
                  },
                  fontFamily: "Roboto",
                  fontSize: "30px",
                  fontWeight: 600,
                  lineHeight: "35px",
                }}
              >
                {authUser ? authUser.companyName : ""}
                {/* National Construction Carrier */}
              </Typography>
              <Typography
                component="p"
                sx={{
                  display: {
                    xs: isOpen ? "block" : "none",
                  },
                }}
              >
                Hotel Management
              </Typography>
            </div>
            <CloseIcon
              className="icons"
              onClick={toggle}
              sx={{ display: { md: isOpen ? "block" : "none", xs: "block" } }}
            />
            <ArrowCircleRightRoundedIcon
              className="icon"
              onClick={toggle}
              sx={{ display: { md: !isOpen ? "block" : "none", xs: "none" } }}
            />
          </Box>
          <Box
            sx={{
              maxWidth: { xs: "350px", md: "auto" },
              mx: { xs: "auto", md: 0 },

              //for temnder and employeemente
            }}
          >
            {sidebardata
              .filter((item) => isRouteAllowed(item.checkAdminRules))
              .map((item, index) => (
                <AppMenuItem
                  {...item}
                  key={index}
                  className="appMenu"
                  setIsOpen={setIsOpen}
                  isOpen={isOpen}

                //for temnder and employeemente
                />
              ))}
          </Box>
        </List>
      </Box>
    </Box>
  );
};

export default Sidebar;
